export default {
  AUTH_KEY: "Fx9T8/h3ZR9rC8jwOLa6Ht05QAA=/Qsp"
};
